export default __webpack_public_path__ + "static/media/baseCampBg.23f82b64.webp";